<div class="main-content">
  <div class="container-fluid">
    <div class="header-container">
      <button mat-raised-button color="primary" (click)="goBack()" class="add-button m-1">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>

    </div>
    <mat-tab-group>
      <mat-tab label="Vendor Information">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-danger">
                <h4 class="card-title">
                  {{ vendorId() ? 'Edit Vendor' : 'Add Vendor' }}
                </h4>
              </div>
              <div class="card-body">
                <form [formGroup]="vendorForm">
                  <div class="row">
                    <mat-form-field class="col-md-6">
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="first_name" required />
                      @if (vendorForm.get('first_name')?.errors?.['required'] && vendorForm.get('first_name')?.touched) {
                      <mat-error>First name is required</mat-error>
                      }
                    </mat-form-field>

                    <mat-form-field class="col-md-6">
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="last_name" />
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field class="w-100">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" required />
                        @if (vendorForm.get('email')?.touched) {
                          @if (vendorForm.get('email')?.errors?.['required']) {
                          <mat-error>Email is required</mat-error>
                          } @else if (vendorForm.get('email')?.errors?.['email']) {
                          <mat-error>Please enter a valid email address</mat-error>
                          }
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <fh-form-autocomplete
                        [options]="phoneCountryCodeOptions()"
                        label="Phone Country Code"
                        placeholder="Select country code"
                        formControlName="phone_country_code"
                        [required]="true"
                      />
                      @if (vendorForm.get('phone_country_code')?.invalid && vendorForm.get('phone_country_code')?.touched) {
                      <div class="field-error">Phone country code is required</div>
                      }
                    </div>
                    <div class="col-md-6">
                      <mat-form-field class="w-100">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone_number" required />
                        @if (vendorForm.get('phone_number')?.errors?.['required'] && vendorForm.get('phone_number')?.touched) {
                        <mat-error>Phone number is required</mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row">
                    <mat-form-field class="col-md-12">
                      <mat-label>Street</mat-label>
                      <input matInput formControlName="street" />
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <mat-form-field class="col-md-6">
                      <mat-label>City</mat-label>
                      <input matInput formControlName="city" />
                    </mat-form-field>
                    <mat-form-field class="col-md-3">
                      <mat-label>State</mat-label>
                      <input matInput formControlName="state" />
                    </mat-form-field>
                    <mat-form-field class="col-md-3">
                      <mat-label>Postal Code</mat-label>
                      <input matInput formControlName="postal_code" />
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <fh-form-autocomplete
                        [options]="iso2Options()"
                        label="Country"
                        formControlName="iso2"
                        placeholder="Select country"
                        [required]="true"
                      />
                      @if (vendorForm.get('iso2')?.invalid && vendorForm.get('iso2')?.touched) {
                      <div class="field-error">Country is required</div>
                      }
                    </div>
                    <div class="col-md-6">
                      <fh-form-autocomplete
                        [options]="statusOptions"
                        label="Status"
                        formControlName="status"
                        [required]="false"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <mat-form-field class="col-md-6">
                      <mat-label>Password</mat-label>
                      <input matInput type="password" formControlName="password" />
                      @if (vendorForm.get('password')?.errors?.['invalidPassword'] && vendorForm.get('password')?.touched) {
                      <mat-error>Password must be at least 8 characters</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="col-md-6">
                      <mat-label>Description</mat-label>
                      <textarea
                        matInput
                        formControlName="description"
                        rows="2"
                        maxlength="150"
                        placeholder="A few lines about the store, shown under its logo"
                      ></textarea>
                      <mat-hint align="end">{{ (vendorForm.get('description')?.value || '').length }}/150</mat-hint>
                      @if (vendorForm.get('description')?.errors?.['maxlength']) {
                      <mat-error>Keep it to 150 characters</mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <mat-checkbox formControlName="isStarSeller" class="mt-3">Star Seller</mat-checkbox>
                    </div>
                  </div>

                  <!-- Saved at once (not with the form below): customers' phone
                       numbers on this merchant's shipping labels and order emails. -->
                  @if (vendorId()) {
                    <div class="row">
                      <div class="col-md-12">
                        <mat-checkbox
                          class="mt-2"
                          [checked]="showCustomerContact()"
                          [disabled]="savingContact()"
                          (change)="setShowCustomerContact($event.checked)"
                        >
                          Show Customer Contact Number
                        </mat-checkbox>
                        <div class="contact-hint">
                          On shipping labels and order emails. Off: FishyHub's contact is shown instead.
                          @if (contactStatus()) {
                            <strong>{{ contactStatus() }}</strong>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <mat-checkbox
                          class="mt-2"
                          [checked]="chatEnabled()"
                          [disabled]="savingChat()"
                          (change)="setChatEnabled($event.checked)"
                        >
                          Enable messaging
                        </mat-checkbox>
                        <div class="contact-hint">
                          Shoppers can message this store from its products and store page. Turn off to hide the Message button and stop new messages.
                          @if (chatStatus()) {
                            <strong>{{ chatStatus() }}</strong>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Profile Picture Section -->
                  @if (vendorId()) {
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <h5>Profile Picture</h5>
                        @if (profilePicUrl() || profilePicBase64()) {
                          <div class="mt-2">
                            @if (profilePicBase64()) {
                              <img [src]="profilePicBase64()" alt="Profile Picture Preview" 
                                style="max-width: 200px; max-height: 200px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 5px;" />
                            } @else {
                              <img fhImageUrl [originalUrl]="profilePicUrl()" alt="Profile Picture" 
                                style="max-width: 200px; max-height: 200px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 5px;" />
                            }
                          </div>
                        }
                        <div class="mt-2">
                          <input type="file" #profilePicInput name="profile_pic" 
                            (change)="uploadProfilePicture(profilePicInput)" 
                            accept="image/png, image/jpeg, image/jpg" />
                        </div>
                        <div class="mt-2">
                          @if (profilePicBase64()) {
                            <button mat-raised-button color="accent" (click)="saveProfilePicture()">
                              <mat-icon>save</mat-icon>
                              Save Profile Picture
                            </button>
                          }
                          @if (profilePicUrl()) {
                            <button mat-raised-button color="warn" (click)="deleteProfilePicture()" class="ml-2">
                              <mat-icon>delete</mat-icon>
                              Delete Profile Picture
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  <div class="row mt-3">
                    <div class="col-md-12">
                      @if (success()) {
                      <div class="alert alert-success mb-3">{{ success() }}</div>
                      }
                      @if (error()) {
                      <div class="alert alert-danger mb-3 d-flex justify-content-between align-items-start">
                        <div>
                          <strong>Save Failed</strong><br />
                          {{ error() }}
                        </div>
                        <button type="button" class="btn-close ms-3" (click)="error.set('')" aria-label="Dismiss"></button>
                      </div>
                      }
                      <button mat-raised-button color="primary" (click)="saveVendor()">
                        Save Vendor
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Delivery Information Tab -->
      @if (vendorId()) {
      <mat-tab label="Delivery Information">
        <div class="row mt-3">
          <div class="col-md-12">
            <fh-vendor-delivery-info [vendorId]="vendorId()"></fh-vendor-delivery-info>
          </div>
        </div>
      </mat-tab>
      }

      <!-- Vendor Performance Tab — the one part of a product's score a person sets -->
      @if (vendorId()) {
      <mat-tab label="Vendor Performance">
        <div class="row mt-3">
          <div class="col-md-12">
            <fh-vendor-performance [vendorId]="vendorId()"></fh-vendor-performance>
          </div>
        </div>
      </mat-tab>
      }

      <!-- Merchant Guidelines Tab — the merchant's own house rules, editable here too -->
      @if (vendorId()) {
      <mat-tab label="Merchant Guidelines">
        <div class="row mt-3">
          <div class="col-md-12">
            <fh-vendor-shop-guideline [vendorId]="vendorId()"></fh-vendor-shop-guideline>
          </div>
        </div>
      </mat-tab>
      }

      <!-- Product Sync Tab — vendors with a sync source -->
      @if (showProductSync()) {
      <mat-tab label="Product Sync">
        <div class="row mt-3">
          <div class="col-md-12">
            <fh-vendor-product-sync [vendorId]="vendorId()"></fh-vendor-product-sync>
          </div>
        </div>
      </mat-tab>
      }
    </mat-tab-group>

  </div>
</div>